import Choices from 'choices.js'

window.addEventListener('load', () => {
  // const selectInputs = document.querySelectorAll(`[data-item="select-input"]`)

  // if (selectInputs.length > 0) {
  //   selectInputs.forEach((selectInput) => {
  //     const choicesInput = new Choices(selectInput, {
  //       allowHTML: true,
  //       placeholder: true,
  //       placeholderValue: 'Type and add multiple options',
  //     })
  //   })
  // }

  const selects = document.querySelectorAll(`[data-form-select]`)
  if (selects.length > 0) {
    selects.forEach((select) => {
      const choices = new Choices(select, {
        allowHTML: true,
      })
    })
  }

  // const selectsMultiple = document.querySelectorAll(
  //   `[data-item="select-multiple"]`,
  // )
  // if (selectsMultiple.length > 0) {
  //   selectsMultiple.forEach((selectMultiple) => {
  //     const choicesMultiple = new Choices(selectMultiple, {
  //       allowHTML: true,
  //       placeholderValue: 'Choose a options',
  //     })
  //   })
  // }
})
